import Checkbox from '@/components/Checkbox/Checkbox';
import UpgradeV2Image from '@/images/agents/UpgradeV2Edit.jpg';
import { useAnalytics } from '@/services/analytics';
import styled from '@emotion/styled';
import { CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import { MainText, StyledButton, StyledDialog, Text, TextContainer } from './common';

const Row = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const StyledCheckbox = styled.label`
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 1.6rem;
    user-select: none;

    input {
        width: 20px;
        height: 20px;
        background-color: black;
    }
`;

const StyledCircularProgress = styled(CircularProgress, { shouldForwardProp: propName => propName !== 'dark' })<{ dark: boolean }>`
    color: ${({ dark }) => (dark ? '#000' : '#fff')};
    height: 12px !important;
    width: 12px !important;
`;

interface Props {
    isOpen: boolean;
    onClose(): void;
    onSubmit(disableModal: boolean): Promise<void>;
}

export function UpgradeV2Modal({ isOpen, onClose, onSubmit }: Props) {
    const mixpanel = useAnalytics();
    const [showCheckbox, setShowCheckbox] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        mixpanel?.track('agents-upgrade-v2', { event: 'view', from: 'upgrade-modal' });
    }, [mixpanel]);

    return (
        <StyledDialog open={isOpen} onClose={onClose}>
            <img src={UpgradeV2Image} />
            <TextContainer>
                <Text>Upgrade to Agents 2.0</Text>
                <MainText>
                    Ready for an upgrade? We’ll create a new version of your agent while keeping your current one untouched. Enjoy better
                    conversations, more customization, and fresh display options—free! Click ‘Let’s go’ to get started
                </MainText>
            </TextContainer>
            <Row>
                <StyledCheckbox>
                    <Checkbox checked={showCheckbox} onClick={_ => setShowCheckbox(!showCheckbox)} />
                    Don’t show this again
                </StyledCheckbox>
                <StyledButton
                    main
                    disabled={isLoading}
                    onClick={async () => {
                        setIsLoading(true);
                        await onSubmit(showCheckbox);
                        setIsLoading(false);
                    }}
                    variant="contained"
                    color="primary">
                    {!isLoading ? 'Let’s go' : <StyledCircularProgress dark={false} />}
                </StyledButton>
            </Row>
        </StyledDialog>
    );
}
